export function downloadFile(file: File): void;
export function downloadFile(file: Blob, fileName: string): void;
export function downloadFile(file: Blob | File, name?: string) {
  const a = document.createElement("a");
  a.href = URL.createObjectURL(file);
  a.download = (file as File).name ?? name;
  a.click();
  URL.revokeObjectURL(a.href);
}
